export default "__VITE_ASSET__98830caa__"